export const BrowserRoute = {
    HOME: '/',
    HOME_FILTER: ':filter'
};
